import Swiper from 'swiper';
import {Navigation, A11y, Keyboard, Autoplay} from "swiper/modules";
if(document.querySelectorAll('.event-calendar')) {
    document.addEventListener('DOMContentLoaded', (event) => {
        const calendars = document.querySelectorAll('.event-calendar')
        calendars.forEach(calendar => {
            const searchCategories = calendar.querySelectorAll(".event-overview-filter-list .event-overview-filter-item");
            const teasers = calendar.querySelectorAll('.event-list-teaser')
            let month = {
                "Januar": [0,'',0], // [first occurrence of month, year of first occurrence, set month of next year]
                "Februar": [0,'',0],
                "Maerz": [0,'',0],
                "April": [0,'',0],
                "Mai": [0,'',0],
                "Juni": [0,'',0],
                "Juli": [0,'',0],
                "August": [0,'',0],
                "September": [0,'',0],
                "Oktober": [0,'',0],
                "November": [0,'',0],
                "Dezember": [0,'',0]
            }
            const teaserCount = (count, item, itemText, itemMonth, itemYear) => {
                teasers.forEach(teaser => {
                    let teaserMonth = teaser.dataset.month
                    teaserMonth === 'März' ? teaserMonth = 'Maerz' : teaserMonth
                    if(itemMonth !== 'all' && (teaserMonth === itemMonth && teaser.dataset.year === itemYear)) {
                        count++
                    } else if(itemMonth === 'all') {
                        count++
                    }
                })
                itemText = itemText + ' ' + '('+count.toString()+')'
                item.querySelector('span').textContent = itemText
            }
            const filterEvent = (item, itemMonth, itemYear) => {
                item.addEventListener('click', (event) => {
                    let visibleTeaser = []
                    if(!item.classList.contains('active')) {
                        searchCategories.forEach(cat => {
                            cat.classList.remove('active')
                        })
                        item.classList.add('active')
                    }
                    teasers.forEach(teaser => {
                        let teaserMonth = teaser.dataset.month
                        teaserMonth === 'März' ? teaserMonth = 'Maerz' : teaserMonth
                        if(itemMonth !== 'all' && (teaserMonth !== itemMonth || teaser.dataset.year !== itemYear)) {
                            teaser.setAttribute('style', 'display: none')
                        } else {
                            teaser.removeAttribute('style')
                            if (teaser.getAttribute('style') === null) {
                                visibleTeaser.push(teaser)
                            }
                        }
                    })
                    const setHeight = (nextFewItems) => {
                        const heightsHeadline = []
                        const heightsLocation = []
                        const heights = []
                        new Promise(resolve => {
                            nextFewItems.forEach(item => {
                                heightsHeadline.push(item.querySelector('h4').offsetHeight)
                                heightsLocation.push(item.querySelector('.event-teaser-location').offsetHeight)
                            })
                            heights[0] = Math.max(...heightsHeadline)
                            heights[1] = Math.max(...heightsLocation)
                            resolve(heights)
                        }).then((heights) => {
                            nextFewItems.forEach(item => {
                                item.querySelector('h4').setAttribute('style', 'min-height:' + heights[0].toString() + 'px')
                                item.querySelector('.event-teaser-location').setAttribute('style', 'min-height:' + heights[1].toString() + 'px')
                            })
                        })
                    }
                    const nextItems = (visibleTeaser, startIndex, fourTeaserFlag) => {
                        visibleTeaser.forEach(item => {
                            item.querySelector('h4').removeAttribute('style')
                            item.querySelector('.event-teaser-location').removeAttribute('style')
                        })
                        if(window.innerWidth >= 1024) { //3er grid
                            return !fourTeaserFlag ? visibleTeaser.slice(startIndex, startIndex + 3) : visibleTeaser.slice(startIndex, startIndex + 4);
                        } else if(window.innerWidth < 1024 && window.innerWidth >= 640) { //2er grid
                            return visibleTeaser.slice(startIndex, startIndex + 2);
                        } else {
                            return visibleTeaser.slice(startIndex, startIndex + 1);
                        }
                    }
                    let startIndex = 0;
                    while (startIndex < visibleTeaser.length) {
                        const fourTeaserFlag = !!visibleTeaser[0].parentNode.parentNode.classList.contains('four-teaser')
                        const nextFewItems = nextItems(visibleTeaser, startIndex, fourTeaserFlag);
                        setHeight(nextFewItems);
                        if(window.innerWidth >= 1024) {
                            switch (fourTeaserFlag) {
                                case true:
                                    startIndex += 4;
                                    break;
                                default:
                                    startIndex += 3;
                            }
                        } else if(window.innerWidth < 1024 && window.innerWidth >= 640) {
                            startIndex += 2;
                        } else {
                            startIndex += 1;
                        }
                    }
                })
            }
            searchCategories.forEach(item => {
                let itemMonth = item.dataset.month
                itemMonth === 'März' ? itemMonth = 'Maerz' : itemMonth
                const itemYear = item.dataset.year
                let itemText = item.querySelector('span').textContent
                let count = 0
                if (itemMonth !== 'all' && month[`${itemMonth}`][0] !== 1) { // first occurrence of a month
                    month[`${itemMonth}`][0] = 1 // we set the first occurrence of a month
                    month[`${itemMonth}`][1] = itemYear  // we set the year of the first occurrence of a month
                    teaserCount(count, item, itemText, itemMonth, itemYear)
                    item.removeAttribute('style')
                    filterEvent(item, itemMonth, itemYear)
                } else if (itemMonth !== 'all' && month[`${itemMonth}`][0] === 1 && month[`${itemMonth}`][1] !== itemYear && month[`${itemMonth}`][2] !== 1) {  // second occurrence of a month, if it's the next year and first occurrence in the next year
                    month[`${itemMonth}`][2] = 1 // we set the second occurrence of a month
                    teaserCount(count, item, itemText, itemMonth, itemYear)
                    item.removeAttribute('style')
                    filterEvent(item, itemMonth, itemYear)
                } else if(itemMonth === 'all') {
                    teaserCount(count, item, itemText, itemMonth, itemYear)
                    item.removeAttribute('style')
                    filterEvent(item, itemMonth, itemYear)
                } else {
                    item.remove()
                }
            })
            const swiper = new Swiper(calendar.querySelector('.swiper'), {
                slidesPerView: 'auto',
                spaceBetween: 0,
                modules: [Navigation, A11y, Keyboard, Autoplay],
                keyboard: {
                    enabled: true
                },
                navigation: {
                    nextEl: calendar.querySelector('.swiper-button-next'),
                    prevEl: calendar.querySelector('.swiper-button-prev'),
                },
            })
            calendar.querySelector('li[data-month="all"]').click()
        })

    })
}
